class DebugLog {
    static IsDebug = () => localStorage.getItem('debug') === '1'
    static Log = (message, logFn) => {
        if (this.IsDebug()) logFn(message)
    }

    static Info = (message) => {
        this.Log(message, console.info)
    }

    static Error = (message) => {
        this.Log(message, console.error)
    }
}

export default DebugLog
